module.exports = __webpack_public_path__ + "img/5.08.thmb.xs.8518c576.jpg";